import { Molecule, wrap, Wrapper } from 'AppReact';
import styled from 'styled-components';
import { NoWrap, Icon } from 'atoms';

const template = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  gap: 4px;
  cursor: pointer;
`;

export default Molecule({
  type:"button",
  template,
  atoms: [
    {
      component: Icon,
      name: 'ActiveIcon',
      displayValue: ({ icon }) => icon,
      renderIf: ({ icon }) => !!icon
    },
    {
      component: NoWrap,
      name: 'Text',
      displayValue: ({ text }) => text,
    },
  ],
})
